module.exports = __webpack_public_path__ + "static/media/static-1.f4fce2a7.png";